export const formatDate = (date: Date) => {
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${date.getFullYear()}-${
    month >= 10 ? month : `0${month}`
  }-${day >= 10 ? day : `0${day}`}`;
}

export const formatTime = (time: Date) => {
  const h = time.getHours() ?? 0;
  const m = time.getMinutes() ?? 0;
  return `${h >= 10 ? h : `0${h}`}:${
    m >= 10 ? m : `0${m}`
  }:00`;
}